import { toast } from 'react-toastify';

export function buildSendPayload(noteMode, selectedNoteTypes, selectedPatientId) {
  const writingNote = !!noteMode && !!selectedPatientId;

  if (noteMode && !selectedPatientId) {
    toast.info('Chat will proceed without saving a note. Select a patient to write a note.');
  }

  const notePrefs = writingNote
    ? {
        write_soap: selectedNoteTypes?.soap ?? true,
        client_summary: selectedNoteTypes?.client_summary ?? false,
        therapist_reflection: selectedNoteTypes?.therapist_reflection ?? false,
        patient_id: selectedPatientId,
      }
    : null;

  const extra = writingNote ? { patient_id: selectedPatientId } : null;

  return { writingNote, notePrefs, extra };
}
